import config from '@/config'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.COMMU}/api/next-capital/customer`,
    timeout: 30000,
    headers: {
      AUTHORIZATION:
        'Bearer OEg4MkxMVEtrWlVpYXRkRnhsWmVteXZxeis4TU5UejBURFo0ZDlXbU1Xc2FSdDhGbU5HdWpvK2hEVThvN0VQcVVmbjV3L0FMUnpUYUZxMTZGWnVFNWtPbWtEWWd2azBpb3RlbFg0dStOc0k2RFpBUUxWWWxjTkh5c2puMm45dmVQd2YzMkdxZmEwQUlKQ3FaVkxUTVJnZEIwNHQ4OS8xTy93MWNEbnlpbEZVPQ=='
    }
  })

const consendApi = {
  getConsendTemplate: config => {
    return instance().get(`/consetnt-template`, config)
  },
  postUserConsend: request => {
    const { body, config } = request
    return instance().post(`/user-consetnt`, body, config)
  },
  getUserConsend: params => {
    return instance().get(`/consetnt-list`, { params })
  },
  getConsendTemplateV2: config => {
    return instance().get(`/v2/consent-template`, {
      ...config
    })
  },
  postUserConsendV2: request => {
    const { body, config } = request
    return instance().post(`/v2/user-consetnt`, body, {
      ...config,
      headers: {
        AUTHORIZATION:
          'Bearer OEg4MkxMVEtrWlVpYXRkRnhsWmVteXZxeis4TU5UejBURFo0ZDlXbU1Xc2FSdDhGbU5HdWpvK2hEVThvN0VQcVVmbjV3L0FMUnpUYUZxMTZGWnVFNWtPbWtEWWd2azBpb3RlbFg0dStOc0k2RFpBUUxWWWxjTkh5c2puMm45dmVQd2YzMkdxZmEwQUlKQ3FaVkxUTVJnZEIwNHQ4OS8xTy93MWNEbnlpbEZVPQ=='
      }
    })
  },
  getUserConsendV2: params => {
    return instance().get(`/v2/consent-list`, { params })
  }
}
export default consendApi
